import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
// images
import imageDesktopWebp from './images/pcg-hero.webp';
import imageTabletWebp from './images/pcg-hero-tablet.webp';
import imageMobileWebp from './images/pcg-hero-mobile.webp';
// low res images
import { lowResImageDesktop } from './lowResImages';
// styles
import {
  ColStyled,
  DivStyledBgContainer,
  RowStyled,
  SectionContainerStyled,
  SpanStyledBlock,
  TypographyStyled,
} from './styles';

export default () => {
  const theme = useContext(ThemeContext);
  const largeUp = theme.largeUp();
  const mediumUp = theme.mediumUp();
  const [heroImage, setImage] = useState(lowResImageDesktop);

  const setHeroImage = () => {
    if(largeUp){
      setImage(imageDesktopWebp);
    }else if(mediumUp){
      setImage(imageTabletWebp);
    }else{
      setImage(imageMobileWebp);
    }
  };

  // on resize
  useEffect(() => {
    setHeroImage();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediumUp]);

  return (
    <SectionContainerStyled
      id='private-wealth-management-hero'
      role='banner'
      backgroundVariant='darkDefault'
      themeType='darkTheme'
      branding='pcg'
      disableBottomPadding>
      <RowStyled align='center'>
        <ColStyled large={6}>
          <TypographyStyled
            id='private-wealth-management-hero'
            component='h1'
            variant='h2'
            themeType='darkTheme'
            align='center'
            branding='pcg'
            uppercase>
            <SpanStyledBlock>
              Northwestern Mutual
            </SpanStyledBlock>
            <SpanStyledBlock>
              Private Client Group
            </SpanStyledBlock>
          </TypographyStyled>
        </ColStyled>
        <ColStyled large={6}>
          <DivStyledBgContainer
            id='private-wealth-management-bg-container'
            heroImage={heroImage.toString()}
          />
        </ColStyled>
      </RowStyled>
    </SectionContainerStyled>
  );
};
